export type IAnnouncementTargetType = 'buyer' | 'seller' | 'agent' | 'all';

export type IAnnouncementCategory = 'seminar' | 'maintenance' | 'feature' | 'other' | 'news' | 'pr' | 'agent_news';

export const ANNOUNCEMENT_CATEGORY_LABELS: Record<IAnnouncementCategory, string> = {
    seminar: 'セミナー',
    maintenance: 'メンテナンス',
    feature: '機能追加',
    other: 'その他',
    news: 'お知らせ',
    pr: 'PR',
    agent_news: '登録仲介会社のお知らせ',
};

export interface IAnnouncement {
    id: string;
    target_type: IAnnouncementTargetType;
    title: string;
    content: string;
    category?: IAnnouncementCategory;
    publish_start: string;
    publish_end?: string;
    created_at: string;
    updated_at: string;
}
